import type { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "Data/Redux/Store";
import { type SnmpSettingsState, SnmpAuthenticationProtocol, SnmpPrivacyProtocol, SnmpType } from "Interfaces";

const initialState: SnmpSettingsState = {
	snmpType: SnmpType.NONE,
	v2: {
		writeCommunity: "",
		readCommunity: "",
		trapAddress: "",
		trapCommunity: "",
		trapEnabled: false,
		trapOptions: {
			authFailure: false,
			networkConnection: false,
			otherOption: false
		}
	},
	v3: {
		trapAddress: "",
		trapCommunity: "",
		trapEnabled: false,
		trapOptions: {
			authFailure: false,
			networkConnection: false,
			otherOption: false
		},
		authPassword: "",
		authProtocol: SnmpAuthenticationProtocol.NONE,
		privacyPassword: "",
		privacyProtocol: SnmpPrivacyProtocol.NONE,
		username: ""
	}
};

export const setSnmpReducer = (state: SnmpSettingsState, action: PayloadAction<SnmpSettingsState>) => {
	return action.payload;
};

export const getSnmp = (state: SnmpSettingsState) => {
	return state;
};

const snmpSlice = createAppSlice({
	name: "snmp",
	initialState,
	reducers: {
		setSnmpAction: setSnmpReducer
	},
	selectors: {
		selectSnmp: getSnmp
	}
});

export default snmpSlice;

export const { setSnmpAction } = snmpSlice.actions;
export const { selectSnmp } = snmpSlice.selectors;
